module.exports = __webpack_public_path__ + "img/amex.dc2d7e4.png";